import React from 'react';

import { Link } from 'react-router-dom';

import { DepYatUsername } from '@pkg/components/deprecated';
import { useBreakpoints, useDateString } from '@pkg/hooks';

import { type ActivityListEntryType } from '@app/client';
import { determineTier } from '@app/floorGame';
import { getMashedUrl, getNftDetailsUrl } from '@app/helpers';
import { ReactComponent as EthIcon } from '@app/pages/NFTDetailView/assets/icons/eth.svg';

import { ActivityEntryStatus } from '../ActivityEntryStatus';

import {
    Date,
    Ellipsis,
    FloorContainer,
    FloorLabel,
    FloorValue,
    FloorWrapper,
    Image,
    Info,
    LeftSide,
    Name,
    RightSide,
    Value,
    WalletWrapper,
    Wrapper,
    YatRow,
} from './styles';

const ACCOUNT_LENGTH = 4;

export const ActivityEntry = ({ data }: { data: ActivityListEntryType }) => {
    const { image, name, owner_yat, twitter_handle, value, date, status, contract_address, id, slug, wallet_address } =
        data;

    const { isMobile } = useBreakpoints();

    const mashedImageUrl = getMashedUrl({
        width: 500,
        url: image,
        skipReMash: true,
    });

    const { dateTimeAgo, dateFull } = useDateString(date);
    const itemUrl = slug
        ? `/collection/ethereum/${slug}`
        : getNftDetailsUrl({ contractAddress: contract_address, tokenId: id, goBackEnabled: true });
    const tier = slug && value ? determineTier(value) : '';

    return (
        <Link to={itemUrl}>
            <Wrapper $floorPriceTier={tier}>
                <LeftSide>
                    <Image $isFloorPrice={Boolean(tier)} $image={mashedImageUrl || ''} />
                    <Info>
                        {name && <Name>{name}</Name>}
                        <YatRow>
                            {owner_yat ? (
                                <DepYatUsername
                                    yat={owner_yat}
                                    twitter={isMobile ? '' : twitter_handle}
                                    size="smaller"
                                />
                            ) : (
                                !tier && (
                                    <WalletWrapper>
                                        <Ellipsis>
                                            {wallet_address?.slice(
                                                0,
                                                Math.max(0, wallet_address.length - ACCOUNT_LENGTH),
                                            )}
                                        </Ellipsis>
                                        <span>
                                            {wallet_address?.slice(Math.max(0, wallet_address.length - ACCOUNT_LENGTH))}
                                        </span>
                                    </WalletWrapper>
                                )
                            )}
                            <Date title={dateFull}>{dateTimeAgo}</Date>
                        </YatRow>
                    </Info>
                </LeftSide>
                <RightSide>
                    {tier ? (
                        <FloorContainer>
                            <FloorWrapper>
                                <FloorLabel>New floor</FloorLabel>
                                <FloorValue>{value}</FloorValue>
                            </FloorWrapper>

                            <EthIcon />
                        </FloorContainer>
                    ) : (
                        <>
                            {Boolean(value) && (
                                <Value>
                                    <EthIcon />
                                    {value}
                                </Value>
                            )}
                            <ActivityEntryStatus status={status} />
                        </>
                    )}
                </RightSide>
            </Wrapper>
        </Link>
    );
};
